import { PageData, Rect, Word } from './constants';
import { CitationReferenceData } from '../../../../services/reference-generator/types';

export function mergeRects(rects: Rect[]): Rect[] {
  if (rects.length === 0) return [];
  const sorted = [...rects].sort((a, b) => a.top - b.top || a.left - b.left);
  const merged: Rect[] = [];
  let current = sorted[0];

  for (let i = 1; i < sorted.length; i++) {
    const next = sorted[i];
    const sameLine = Math.abs(current.top - next.top) < current.height * 0.8;
    if (sameLine) {
      const newLeft = Math.min(current.left, next.left);
      const newRight = Math.max(current.left + current.width, next.left + next.width);
      const newTop = Math.min(current.top, next.top);
      const newBottom = Math.max(current.top + current.height, next.top + next.height);
      current = { left: newLeft, top: newTop, width: newRight - newLeft, height: newBottom - newTop };
    } else {
      merged.push(current);
      current = next;
    }
  }
  merged.push(current);
  return merged;
}


export function getRectsForTokenRef(tokenRef: { token_ids: number[] } | undefined, pageData: PageData): Rect[] | null {
  if (!tokenRef || tokenRef.token_ids.length === 0) return null;
  const wordMap = new Map(pageData.words.map(w => [w.id, w]));
  const rects = tokenRef.token_ids
    .map(id => wordMap.get(id))
    .filter((w): w is Word => w !== undefined)
    .map(w => ({ left: w.left, top: w.top, width: w.width, height: w.height }));
  return rects.length > 0 ? mergeRects(rects) : null;
}

export function getActiveCitationRectsForPage(
  activeCitation: CitationReferenceData | undefined,
  pageData: PageData | undefined,
  activeTokenRefIndex: number
): { focused: Rect[] | null; dimmed: Rect[][] } {
  if (!activeCitation || !pageData) return { focused: null, dimmed: [] };

  const activeRef = activeCitation.tokenReferences[activeTokenRefIndex];
  const focused = getRectsForTokenRef(activeRef, pageData);

  const dimmed: Rect[][] = [];
  activeCitation.tokenReferences.forEach((ref, i) => {
    if (i === activeTokenRefIndex) return;
    const rects = getRectsForTokenRef(ref, pageData);
    if (rects) dimmed.push(rects);
  });

  return { focused, dimmed };
}
